import { Place } from '@/types/google-maps.types';

export type OverridedUserLocation = Pick<Place, 'city' | 'state'> & Partial<Pick<Place, 'latitude' | 'longitude' | 'formattedAddress'>>;

export const formatPlaceFromSlug = (slug: string): OverridedUserLocation => {
  const parts = slug.split('-');

  if (parts.length < 2) {
    return { city: '', state: '' };
  }

  const city = parts.slice(0, -1).join(' ');

  const state = parts[parts.length - 1].toUpperCase();

  return { city, state };
};
